module.exports = __webpack_public_path__ + "img/icon_menu_event_2.d7fb6c00.svg";